import { Spin } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { AiOutlineEye } from "react-icons/ai";
import { BiEdit } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { api, endpoint } from "../../api";

const DashboardList = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [editId, setEditId] = useState('');

  const getDashboardList = async () => {
    if (!isLoading) {
      setIsLoading(true)
      const response = await api.get(endpoint.get_dashboard_list, {
        params: {
          // deviceId: device,
          limit: 10,
          page: 1,
        },
      });
      console.log(response.data)
      setData(response.data)
      setTotal(response.count)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getDashboardList()
  }, [page, limit]);

  const columns = [
    {
      name: "No.",
      selector: (row, index) => index + 1,
      width: "60px",
    },
    {
      name: "Dashboard Name",
      cell: (row) => row.name,
    },
    {
      name: "Date Created",
      selector: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
      center: true,
    },
    {
      name: "Action",
      width: "220px",
      center: true,
      cell: (row) => (
        <div>
          <Link to={`/dashboardList/${row._id}`}>
            <Button className="me-2 btn-info">
              <AiOutlineEye className="text-white" />
            </Button>
          </Link>
          {/* EditDashboard */}

          <Link to={`/dashboardEdit/${row._id}`}>
            <Button className="me-2">
              <BiEdit className="text-white" />
            </Button>
          </Link>
          <Button className="me-2 btn-danger" onClick={() => deleteHandler(row._id)}>
            <MdDeleteOutline className="text-white" />
          </Button>
        </div>
      ),
    },
  ];

  // handler
  const deleteHandler = id => {
    try {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't to delete it!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await axios.delete(`${endpoint.remove_dashboard}/${id}`, { withCredentials: true });
          if (response.status === 200) {
            Swal.fire(
              'Deleted!',
              'Your file has been deleted.',
              'success'
            )
            getDashboardList()
          }
        }
      })
    } catch (error) {
      console.log(error)
    }
  }



  return (
    <div className="px-3 mt-3">
      <div className="border bg-white p-3">
        {/* <h5>Dashboard List</h5> */}
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <label className="az-content-label">Manage Dashboard</label>
            <span className="d-block py-2">Dashboard List</span>
          </div>
          <div className="col-md-4 d-flex justify-content-end p-0">
            <Link className="btn btn-az-primary btn-md" to="/newDashboard">Create Dashboard</Link>
          </div>
        </div>
        <hr className="mt-0 mb-5" />

        <DataTable
          columns={columns}
          data={data}
          pagination
          paginationServer
          progressPending={isLoading}
          progressComponent={<Spin />}
          noDataComponent={isLoading ? "Loading" : "No record found."}
          className="mt-3"
          paginationTotalRows={total}
          paginationPerPage={limit}
          onChangePage={(data) => {
            setPage(data);
          }}
          onChangeRowsPerPage={(data) => {
            setLimit(data);
            setPage(1);
          }}
          paginationRowsPerPageOptions={[10, 20, 50]}
        />


      </div>

    </div>
  );
};

export default DashboardList;
